/* Legacy code - ignore complexity errors */
/* eslint complexity: 0 */
import React from 'react';
import Flexbox from 'flexbox-react';
import { inject, observer } from 'mobx-react';
import { Button, Classes, Collapse, Intent } from '@blueprintjs/core';
import _ from 'lodash';
import classNames from 'classnames';

@inject('CurrentUserStore', 'AppStore', 'ToastStore')
@observer
export default class AppEditDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      isOpen: false,
      isBlurred: [],
    };
  }

  toggleOpen() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  toggleLoading = () => {
    this.setState({
      isSubmitting: !this.state.isSubmitting,
    });
  };

  handleSubmit(e) {
    e.preventDefault();
    this.toggleLoading();
    this.setState({ isBlurred: [] });
    const newObj = {
      name: this.props.AppStore.newApp.name,
      description: this.props.AppStore.newApp.description,
      item: this.props.AppStore.newApp.item,
      item_plural: this.props.AppStore.newApp.itemPlural,
    };
    this.props.AppStore.changeApp(newObj)
      .then(() => {
        this.toggleLoading();
        this.toggleOpen();
      })
      .catch(() => {
        this.toggleLoading();
      });
  }

  handleInputChange(e) {
    this.props.AppStore.updateNewApp(e.target.value, e.target.name);
  }

  handleCancel() {
    this.props.AppStore.resetAppAttribute('name');
    this.props.AppStore.resetAppAttribute('description');
    this.toggleOpen();
  }

  handleBlurChange(e) {
    if (!_.includes(this.state.isBlurred, e.target.name)) {
      const newBlurState = this.state.isBlurred;
      newBlurState.push(e.target.name);
      this.setState({ isBlurred: newBlurState });
    }
  }

  renderErrors(field) {
    if (
      _.includes(this.state.isBlurred, field) &&
      !this.props.AppStore.newApp[`${field}Valid`]
    ) {
      return (
        <div className="bp3-form-helper-text">
          {this.props.AppStore.newApp[`${field}Error`]}
        </div>
      );
    }
    return undefined;
  }

  render() {
    return (
      <Flexbox
        flexDirection="column"
        flexGrow={1}
        marginBottom="20px"
      >
        <Flexbox
          flexDirection="row"
          justifyContent="space-between"
          flexGrow={1}
        >
          <Flexbox flexDirection="column">
            {/* ignore jsx-a11y as toggle functionality included eslewhere for */}
            {/* eslint-disable-next-line */}
            <h4
              className={`${Classes.HEADING} bp3-cursor-pointer noselect`}
              onClick={() => this.toggleOpen()}
            >
              {I18n.t('js.details')}
            </h4>
            <p className="noselect">
              {I18n.t('js.change_app_name_and_description')}
            </p>
          </Flexbox>
          <Flexbox flexDirection="column">
            <Button
              text={
                this.state.isOpen
                  ? I18n.t('js.close')
                  : I18n.t('js.expand')
              }
              icon={this.state.isOpen ? 'chevron-up' : 'expand-all'}
              onClick={() => this.toggleOpen()}
            />
          </Flexbox>
        </Flexbox>
        <Collapse isOpen={this.state.isOpen}>
          <form onSubmit={this.handleSubmit.bind(this)}>
            <Flexbox flexDirection="column">
              <Flexbox
                flexGrow={1}
                className={
                  _.includes(this.state.isBlurred, 'name') &&
                  !this.props.AppStore.newApp.nameValid
                    ? classNames('bp3-form-group bp3-intent-danger')
                    : classNames('bp3-form-group')
                }
              >
                <label className="bp3-label" htmlFor="name">
                  {I18n.t('js.app_name')}
                  <span className="bp3-text-muted push-5-l">
                    ({I18n.t('js.required')})
                  </span>
                </label>
                <div className="bp3-form-content">
                  <div
                    className={
                      _.includes(this.state.isBlurred, 'name') &&
                      !this.props.AppStore.newApp.nameValid
                        ? classNames(
                            'bp3-input-group bp3-intent-danger'
                          )
                        : classNames('bp3-input-group')
                    }
                  >
                    <input
                      autoComplete="off"
                      className="bp3-input bp3-fill"
                      type="text"
                      placeholder={I18n.t(
                        'js.enter_a_name_for_your_app'
                      )}
                      name="name"
                      value={this.props.AppStore.newApp.name}
                      onChange={this.handleInputChange.bind(this)}
                      onBlur={this.handleBlurChange.bind(this)}
                      dir="auto"
                    />
                  </div>
                  {this.renderErrors('name')}
                </div>
              </Flexbox>
              <Flexbox
                flexGrow={1}
                className={
                  _.includes(this.state.isBlurred, 'description') &&
                  !this.props.AppStore.newApp.descriptionValid
                    ? classNames('bp3-form-group bp3-intent-danger')
                    : classNames('bp3-form-group')
                }
              >
                <label className="bp3-label" htmlFor="description">
                  {I18n.t('js.app_description')}
                  <span className="bp3-text-muted push-5-l">
                    ({I18n.t('js.required')})
                  </span>
                </label>
                <div className="bp3-form-content">
                  <div
                    className={
                      _.includes(
                        this.state.isBlurred,
                        'description'
                      ) &&
                      !this.props.AppStore.newApp.descriptionValid
                        ? classNames(
                            'bp3-input-group bp3-intent-danger'
                          )
                        : classNames('bp3-input-group')
                    }
                  >
                    <textarea
                      className="bp3-input bp3-fill"
                      type="text"
                      placeholder={I18n.t(
                        'js.enter_a_description_for_your_app'
                      )}
                      name="description"
                      value={this.props.AppStore.newApp.description}
                      onChange={this.handleInputChange.bind(this)}
                      onBlur={this.handleBlurChange.bind(this)}
                      dir="auto"
                    />
                  </div>
                  {this.renderErrors('description')}
                </div>
              </Flexbox>
              <Flexbox flexDirection="row">
                <Flexbox flexGrow={1} marginRight="10px">
                  <div
                    className={
                      _.includes(this.state.isBlurred, 'item') &&
                      !this.props.AppStore.newApp.itemValid
                        ? classNames(
                            'bp3-form-group max-width bp3-intent-danger'
                          )
                        : classNames('bp3-form-group max-width')
                    }
                  >
                    <label className="bp3-label" htmlFor="item">
                      {I18n.t('js.item_name')}
                      <span className="bp3-text-muted push-5-l">
                        ({I18n.t('js.required')})
                      </span>
                    </label>
                    <div className="bp3-form-content">
                      <div
                        className={
                          _.includes(this.state.isBlurred, 'item') &&
                          !this.props.AppStore.newApp.itemValid
                            ? classNames(
                                'bp3-input-group bp3-intent-danger'
                              )
                            : classNames('bp3-input-group')
                        }
                      >
                        <input
                          autoComplete="off"
                          className="bp3-input bp3-fill"
                          type="text"
                          placeholder={I18n.t('js.enter_item_name')}
                          name="item"
                          value={this.props.AppStore.newApp.item}
                          onChange={this.handleInputChange.bind(this)}
                          onBlur={this.handleBlurChange.bind(this)}
                          dir="auto"
                        />
                      </div>
                      {this.renderErrors('item')}
                    </div>
                  </div>
                </Flexbox>
                <Flexbox flexGrow={1}>
                  <div
                    className={
                      _.includes(
                        this.state.isBlurred,
                        'itemPlural'
                      ) && !this.props.AppStore.newApp.itemValid
                        ? classNames(
                            'bp3-form-group max-width bp3-intent-danger'
                          )
                        : classNames('bp3-form-group max-width')
                    }
                  >
                    <label className="bp3-label" htmlFor="itemPlural">
                      {I18n.t('js.item_plural_name')}
                      <span className="bp3-text-muted push-5-l">
                        ({I18n.t('js.required')})
                      </span>
                    </label>
                    <div className="bp3-form-content">
                      <div
                        className={
                          _.includes(
                            this.state.isBlurred,
                            'itemPlural'
                          ) && !this.props.AppStore.newApp.itemValid
                            ? classNames(
                                'bp3-input-group bp3-intent-danger'
                              )
                            : classNames('bp3-input-group')
                        }
                      >
                        <input
                          autoComplete="off"
                          className="bp3-input bp3-fill"
                          type="text"
                          placeholder={I18n.t(
                            'js.enter_item_name_plural'
                          )}
                          name="itemPlural"
                          value={
                            this.props.AppStore.newApp.itemPlural
                          }
                          onChange={this.handleInputChange.bind(this)}
                          onBlur={this.handleBlurChange.bind(this)}
                          dir="auto"
                        />
                      </div>
                      {this.renderErrors('itemPlural')}
                    </div>
                  </div>
                </Flexbox>
              </Flexbox>
            </Flexbox>
            <Flexbox>
              <div>
                <Button
                  intent={Intent.PRIMARY}
                  type="submit"
                  disabled={false}
                  text={I18n.t('js.save_changes')}
                  loading={this.state.isSubmitting}
                  icon="tick"
                />
                <Button
                  className="push-10-l"
                  icon="cross"
                  text={I18n.t('js.cancel_changes')}
                  onClick={this.handleCancel.bind(this)}
                />
              </div>
            </Flexbox>
          </form>
        </Collapse>
      </Flexbox>
    );
  }
}
